import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _916ccca4 = () => interopDefault(import('../docs/pages/accessibility.vue' /* webpackChunkName: "pages/accessibility" */))
const _1d3ea704 = () => interopDefault(import('../docs/pages/appbars/index.vue' /* webpackChunkName: "pages/appbars/index" */))
const _66af7c61 = () => interopDefault(import('../docs/pages/buttons.vue' /* webpackChunkName: "pages/buttons" */))
const _6fbfe780 = () => interopDefault(import('../docs/pages/colors.vue' /* webpackChunkName: "pages/colors" */))
const _642b16fe = () => interopDefault(import('../docs/pages/errors/index.vue' /* webpackChunkName: "pages/errors/index" */))
const _8c6cebc4 = () => interopDefault(import('../docs/pages/filters/index.vue' /* webpackChunkName: "pages/filters/index" */))
const _f3ca801e = () => interopDefault(import('../docs/pages/glossary/index.vue' /* webpackChunkName: "pages/glossary/index" */))
const _c54a9f06 = () => interopDefault(import('../docs/pages/icons/index.vue' /* webpackChunkName: "pages/icons/index" */))
const _05bd21d5 = () => interopDefault(import('../docs/pages/kbreadcrumbs.vue' /* webpackChunkName: "pages/kbreadcrumbs" */))
const _1f785a3d = () => interopDefault(import('../docs/pages/kbutton.vue' /* webpackChunkName: "pages/kbutton" */))
const _0fa8a912 = () => interopDefault(import('../docs/pages/kbuttongroup.vue' /* webpackChunkName: "pages/kbuttongroup" */))
const _72c3e4e4 = () => interopDefault(import('../docs/pages/kcheckbox.vue' /* webpackChunkName: "pages/kcheckbox" */))
const _5cbf737d = () => interopDefault(import('../docs/pages/kcircularloader.vue' /* webpackChunkName: "pages/kcircularloader" */))
const _23a4a8c1 = () => interopDefault(import('../docs/pages/kcontentrenderer.vue' /* webpackChunkName: "pages/kcontentrenderer" */))
const _e4c62a8a = () => interopDefault(import('../docs/pages/kdropdownmenu.vue' /* webpackChunkName: "pages/kdropdownmenu" */))
const _15235351 = () => interopDefault(import('../docs/pages/kemptyplaceholder.vue' /* webpackChunkName: "pages/kemptyplaceholder" */))
const _61a8f4e0 = () => interopDefault(import('../docs/pages/kexternallink.vue' /* webpackChunkName: "pages/kexternallink" */))
const _57639bff = () => interopDefault(import('../docs/pages/kfixedgrid.vue' /* webpackChunkName: "pages/kfixedgrid" */))
const _1f0b6bdc = () => interopDefault(import('../docs/pages/kfixedgriditem.vue' /* webpackChunkName: "pages/kfixedgriditem" */))
const _0f705511 = () => interopDefault(import('../docs/pages/kgrid.vue' /* webpackChunkName: "pages/kgrid" */))
const _1affabb8 = () => interopDefault(import('../docs/pages/kgriditem.vue' /* webpackChunkName: "pages/kgriditem" */))
const _5f019678 = () => interopDefault(import('../docs/pages/kicon.vue' /* webpackChunkName: "pages/kicon" */))
const _0d41bc14 = () => interopDefault(import('../docs/pages/kiconbutton.vue' /* webpackChunkName: "pages/kiconbutton" */))
const _7628ec91 = () => interopDefault(import('../docs/pages/klabeledicon.vue' /* webpackChunkName: "pages/klabeledicon" */))
const _2c9ce57a = () => interopDefault(import('../docs/pages/klinearloader.vue' /* webpackChunkName: "pages/klinearloader" */))
const _163caaf2 = () => interopDefault(import('../docs/pages/kmodal.vue' /* webpackChunkName: "pages/kmodal" */))
const _d8a218d2 = () => interopDefault(import('../docs/pages/kpagecontainer.vue' /* webpackChunkName: "pages/kpagecontainer" */))
const _416e0d72 = () => interopDefault(import('../docs/pages/kradiobutton.vue' /* webpackChunkName: "pages/kradiobutton" */))
const _d60593e6 = () => interopDefault(import('../docs/pages/kresponsiveelement.vue' /* webpackChunkName: "pages/kresponsiveelement" */))
const _445dbe22 = () => interopDefault(import('../docs/pages/kresponsivewindow.vue' /* webpackChunkName: "pages/kresponsivewindow" */))
const _5d178bce = () => interopDefault(import('../docs/pages/krouterlink.vue' /* webpackChunkName: "pages/krouterlink" */))
const _1533cd82 = () => interopDefault(import('../docs/pages/kswitch.vue' /* webpackChunkName: "pages/kswitch" */))
const _abcfd3fa = () => interopDefault(import('../docs/pages/ktextbox.vue' /* webpackChunkName: "pages/ktextbox" */))
const _6d078e08 = () => interopDefault(import('../docs/pages/ktooltip.vue' /* webpackChunkName: "pages/ktooltip" */))
const _70a03ffd = () => interopDefault(import('../docs/pages/layout/index.vue' /* webpackChunkName: "pages/layout/index" */))
const _263472ba = () => interopDefault(import('../docs/pages/loaders/index.vue' /* webpackChunkName: "pages/loaders/index" */))
const _0fdc6bd7 = () => interopDefault(import('../docs/pages/menus/index.vue' /* webpackChunkName: "pages/menus/index" */))
const _609af58e = () => interopDefault(import('../docs/pages/modals/index.vue' /* webpackChunkName: "pages/modals/index" */))
const _53abdfa2 = () => interopDefault(import('../docs/pages/pageheader/index.vue' /* webpackChunkName: "pages/pageheader/index" */))
const _7e3655c7 = () => interopDefault(import('../docs/pages/principles.vue' /* webpackChunkName: "pages/principles" */))
const _228dd389 = () => interopDefault(import('../docs/pages/release-process.vue' /* webpackChunkName: "pages/release-process" */))
const _5faf546e = () => interopDefault(import('../docs/pages/snackbars.vue' /* webpackChunkName: "pages/snackbars" */))
const _b51cd6de = () => interopDefault(import('../docs/pages/styling/index.vue' /* webpackChunkName: "pages/styling/index" */))
const _bfe9680e = () => interopDefault(import('../docs/pages/textfields/index.vue' /* webpackChunkName: "pages/textfields/index" */))
const _2396903c = () => interopDefault(import('../docs/pages/writing.vue' /* webpackChunkName: "pages/writing" */))
const _404bc09f = () => interopDefault(import('../docs/pages/icons/IconBlock.vue' /* webpackChunkName: "pages/icons/IconBlock" */))
const _d476a140 = () => interopDefault(import('../docs/pages/icons/IconTable.vue' /* webpackChunkName: "pages/icons/IconTable" */))
const _5882319c = () => interopDefault(import('../docs/pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accessibility",
    component: _916ccca4,
    name: "accessibility"
  }, {
    path: "/appbars",
    component: _1d3ea704,
    name: "appbars"
  }, {
    path: "/buttons",
    component: _66af7c61,
    name: "buttons"
  }, {
    path: "/colors",
    component: _6fbfe780,
    name: "colors"
  }, {
    path: "/errors",
    component: _642b16fe,
    name: "errors"
  }, {
    path: "/filters",
    component: _8c6cebc4,
    name: "filters"
  }, {
    path: "/glossary",
    component: _f3ca801e,
    name: "glossary"
  }, {
    path: "/icons",
    component: _c54a9f06,
    name: "icons"
  }, {
    path: "/kbreadcrumbs",
    component: _05bd21d5,
    name: "kbreadcrumbs"
  }, {
    path: "/kbutton",
    component: _1f785a3d,
    name: "kbutton"
  }, {
    path: "/kbuttongroup",
    component: _0fa8a912,
    name: "kbuttongroup"
  }, {
    path: "/kcheckbox",
    component: _72c3e4e4,
    name: "kcheckbox"
  }, {
    path: "/kcircularloader",
    component: _5cbf737d,
    name: "kcircularloader"
  }, {
    path: "/kcontentrenderer",
    component: _23a4a8c1,
    name: "kcontentrenderer"
  }, {
    path: "/kdropdownmenu",
    component: _e4c62a8a,
    name: "kdropdownmenu"
  }, {
    path: "/kemptyplaceholder",
    component: _15235351,
    name: "kemptyplaceholder"
  }, {
    path: "/kexternallink",
    component: _61a8f4e0,
    name: "kexternallink"
  }, {
    path: "/kfixedgrid",
    component: _57639bff,
    name: "kfixedgrid"
  }, {
    path: "/kfixedgriditem",
    component: _1f0b6bdc,
    name: "kfixedgriditem"
  }, {
    path: "/kgrid",
    component: _0f705511,
    name: "kgrid"
  }, {
    path: "/kgriditem",
    component: _1affabb8,
    name: "kgriditem"
  }, {
    path: "/kicon",
    component: _5f019678,
    name: "kicon"
  }, {
    path: "/kiconbutton",
    component: _0d41bc14,
    name: "kiconbutton"
  }, {
    path: "/klabeledicon",
    component: _7628ec91,
    name: "klabeledicon"
  }, {
    path: "/klinearloader",
    component: _2c9ce57a,
    name: "klinearloader"
  }, {
    path: "/kmodal",
    component: _163caaf2,
    name: "kmodal"
  }, {
    path: "/kpagecontainer",
    component: _d8a218d2,
    name: "kpagecontainer"
  }, {
    path: "/kradiobutton",
    component: _416e0d72,
    name: "kradiobutton"
  }, {
    path: "/kresponsiveelement",
    component: _d60593e6,
    name: "kresponsiveelement"
  }, {
    path: "/kresponsivewindow",
    component: _445dbe22,
    name: "kresponsivewindow"
  }, {
    path: "/krouterlink",
    component: _5d178bce,
    name: "krouterlink"
  }, {
    path: "/kswitch",
    component: _1533cd82,
    name: "kswitch"
  }, {
    path: "/ktextbox",
    component: _abcfd3fa,
    name: "ktextbox"
  }, {
    path: "/ktooltip",
    component: _6d078e08,
    name: "ktooltip"
  }, {
    path: "/layout",
    component: _70a03ffd,
    name: "layout"
  }, {
    path: "/loaders",
    component: _263472ba,
    name: "loaders"
  }, {
    path: "/menus",
    component: _0fdc6bd7,
    name: "menus"
  }, {
    path: "/modals",
    component: _609af58e,
    name: "modals"
  }, {
    path: "/pageheader",
    component: _53abdfa2,
    name: "pageheader"
  }, {
    path: "/principles",
    component: _7e3655c7,
    name: "principles"
  }, {
    path: "/release-process",
    component: _228dd389,
    name: "release-process"
  }, {
    path: "/snackbars",
    component: _5faf546e,
    name: "snackbars"
  }, {
    path: "/styling",
    component: _b51cd6de,
    name: "styling"
  }, {
    path: "/textfields",
    component: _bfe9680e,
    name: "textfields"
  }, {
    path: "/writing",
    component: _2396903c,
    name: "writing"
  }, {
    path: "/icons/IconBlock",
    component: _404bc09f,
    name: "icons-IconBlock"
  }, {
    path: "/icons/IconTable",
    component: _d476a140,
    name: "icons-IconTable"
  }, {
    path: "/",
    component: _5882319c,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
